"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultStore = function (initData) {
    if (initData === void 0) { initData = {}; }
    var data = initData;
    var getItem = function (key) {
        return data[key];
    };
    var setItem = function (key, value) {
        data[key] = value;
        localStorage.setItem(key, value);
    };
    var removeItem = function (key) {
        delete data[key];
        localStorage.removeItem(key);
    };
    return { getItem: getItem, setItem: setItem, removeItem: removeItem };
};
